// extracted by mini-css-extract-plugin
export var aircallIframe = "_k4-3";
export var fabContainer = "_k4-5";
export var fabRinging = "_k4-6";
export var loadingOverlay = "_k4-4";
export var pulse = "_k4-7";
export var widgetContent = "_k4-2";
export var widgetPanel = "_k4-0";
export var widgetPanelExpanded = "_k4-1";